import React, { Component } from "react";
import PropTypes from "prop-types";

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      highlighted: -1
    };
    this.onChange = this.onChange.bind(this);
    this.setHighlighted = this.setHighlighted.bind(this);
    this.toggleExpansion = this.toggleExpansion.bind(this);
  }

  componentWillReceiveProps(props) {
    if (this.props.expanded && !props.expanded) {
      this.setState({
        highlighted: -1
      });
    }
  }

  onChange(value) {
    const { onChange } = this.props;
    if (onChange) {
      onChange(value);
    }
    this.toggleExpansion();
  }

  setHighlighted(highlighted){
    this.setState({
      highlighted
    });
  }

  toggleExpansion() {
    const { doExpand, doCollapse, expanded } = this.props;
    if (expanded) {
      doCollapse();
    } else {
      doExpand();
    }
  }
  render() {
    const { expanded, children, onExpandEvent, title } = this.props;
    const { highlighted } = this.state;
    const options = children.slice ? children.slice(1, children.length) : [];
    return (
      <div
        className={"rdw-dropdown-wrapper"}
        style={{width: '150px'}}
        aria-expanded={expanded}
        aria-label={"rdw-dropdown"}
      >
        <a
          href="#dropdown"
          className="rdw-dropdown-selectedtext"
          onClick={onExpandEvent}
          title={title}
        >
          {children[0]}
          <div
            className={
              expanded
                ? "rdw-dropdown-carettoclose"
                : "rdw-dropdown-carettoopen"
            }
          />
        </a>
        {expanded ? (
          <ul
            className={"rdw-dropdown-optionwrapper"}
            
          >
            {React.Children.map(options, (option, index) => {
              const temp =
                option &&
                React.cloneElement(option, {
                  onSelect: this.onChange,
                  highlighted: highlighted === index,
                  setHighlighted: this.setHighlighted,
                  index
                });
              return temp;
            })}
          </ul>
        ) : (
          undefined
        )}
      </div>
    );
  }
}

Dropdown.propTypes = {
  expanded: PropTypes.bool,
  onExpandEvent: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default Dropdown;
